import type { Template } from "@/types";

export const LA_05_H0_V5: Template[] = [
    {
        id: "la-05-h0v5-01",
        name: "LA 01 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 93, y: 94, width: 227, height: 342, rotation: 0, imageRotation: 0 },
            { id: "2", x: 328, y: 94, width: 227, height: 342, rotation: 0, imageRotation: 0 },
            { id: "3", x: 563, y: 94, width: 227, height: 342, rotation: 0, imageRotation: 0 },
            { id: "4", x: 798, y: 94, width: 227, height: 342, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1033, y: 94, width: 227, height: 342, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-02",
        name: "LA 02 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 67, width: 264, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 272, y: 67, width: 264, height: 397, rotation: 0, imageRotation: 0 },
            { id: "3", x: 544, y: 67, width: 264, height: 397, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 67, width: 264, height: 397, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1088, y: 67, width: 264, height: 397, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-03",
        name: "LA 03 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 142, y: 190, width: 192, height: 291, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 190, width: 192, height: 291, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 190, width: 192, height: 291, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 190, width: 191, height: 291, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1118, y: 190, width: 191, height: 291, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-04",
        name: "LA 04 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 147, y: 0, width: 383, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 800, y: 44, width: 300, height: 442, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1107, y: 44, width: 118, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1107, y: 194, width: 118, height: 142, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1107, y: 345, width: 118, height: 141, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-05",
        name: "LA 05 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 189, y: 51, width: 146, height: 211, rotation: 0, imageRotation: 0 },
            { id: "2", x: 189, y: 270, width: 146, height: 211, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 51, width: 145, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 270, width: 145, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 820, y: 0, width: 388, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-06",
        name: "LA 06 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 123, y: 53, width: 281, height: 428, rotation: 0, imageRotation: 0 },
            { id: "2", x: 412, y: 53, width: 144, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 271, width: 144, height: 210, rotation: 0, imageRotation: 0 },
            { id: "4", x: 777, y: 94, width: 234, height: 342, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1019, y: 94, width: 233, height: 342, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-07",
        name: "LA 07 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 130, y: 44, width: 294, height: 442, rotation: 0, imageRotation: 0 },
            { id: "2", x: 431, y: 44, width: 115, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 431, y: 194, width: 115, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 431, y: 345, width: 115, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 853, y: 44, width: 321, height: 442, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-08",
        name: "LA 08 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 188, y: 49, width: 300, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 860, y: 49, width: 150, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 860, y: 270, width: 150, height: 213, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 49, width: 150, height: 213, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 270, width: 150, height: 213, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-09",
        name: "LA 09 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 106, y: 47, width: 322, height: 436, rotation: 0, imageRotation: 0 },
            { id: "2", x: 435, y: 47, width: 157, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 435, y: 269, width: 157, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 47, width: 321, height: 436, rotation: 0, imageRotation: 0 },
            { id: "5", x: 927, y: 47, width: 321, height: 436, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-10",
        name: "LA 10 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 106, y: 47, width: 322, height: 437, rotation: 0, imageRotation: 0 },
            { id: "2", x: 435, y: 47, width: 321, height: 437, rotation: 0, imageRotation: 0 },
            { id: "3", x: 763, y: 47, width: 321, height: 437, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1091, y: 47, width: 157, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1091, y: 269, width: 157, height: 215, rotation: 0, imageRotation: 0 }
        ],
    }
];